// --------------------------------------------------- grid linked-product selector (color swatch + size dropdown) -------------------------------------------

(function () {
  if (window.__MX_GRID_LINKED__) return;
  window.__MX_GRID_LINKED__ = true;

  // ---------- helpers ----------

  /** Collect all linked-product data for a card into an array of plain objects */
  function parseLinkedData(card) {
    return Array.from(card.querySelectorAll('.mx_grid_linked_data li')).map(function (li) {
      return {
        productId:       li.dataset.productId,
        title:           li.dataset.title || '',
        conesCount:      li.dataset.conesCount || '',
        length:          li.dataset.length,
        paper:           li.dataset.paper,
        paperSwatch:     li.dataset.paperSwatch,
        image:           li.dataset.image,
        imageAlt:        li.dataset.imageAlt || '',
        priceFmt:        li.dataset.priceFmt,
        comparePrice:    parseInt(li.dataset.comparePrice, 10) || 0,
        comparePriceFmt: li.dataset.comparePriceFmt,
        variantId:       li.dataset.variantId,
        url:             li.dataset.url,
        available:       li.dataset.available === 'true',
      };
    });
  }

  /** Mark paper swatches / size options that have no available match for the current selection */
  function updateAvailability(card, products, activePaper, activeLength) {
    var sizeSelect = card.querySelector('.mx_grid_size_select');
    var hasLengthControl = !!(sizeSelect && sizeSelect.options.length);

    card.querySelectorAll('.mx_grid_swatch_btn').forEach(function (btn) {
      var paper = btn.dataset.value || '';
      var ok = products.some(function (p) {
        if (!p.available || p.paper !== paper) return false;
        if (!hasLengthControl) return true;
        return p.length === activeLength;
      });

      btn.classList.toggle('is-disabled', !ok);
      btn.disabled = !ok;
      btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
    });

    if (sizeSelect) {
      Array.prototype.forEach.call(sizeSelect.options, function (opt) {
        var ok = products.some(function (p) {
          if (!p.available || p.length !== opt.value) return false;
          if (!activePaper) return true;
          return p.paper === activePaper;
        });

        opt.disabled = !ok;
        opt.classList.toggle('is-disabled', !ok);
      });
    }
  }

  /** Find best product match: exact paper+length, or fall back to same paper / same length */
  function findProduct(products, paper, length) {
    // 1. Exact match
    var exact = products.find(function (p) { return p.paper === paper && p.length === length; });
    if (exact) return exact;
    // 2. Same paper, any length
    var samePaper = products.find(function (p) { return p.paper === paper; });
    if (samePaper) return samePaper;
    // 3. Same length, any paper
    var sameLength = products.find(function (p) { return p.length === length; });
    return sameLength || null;
  }

  /** Apply a selected linked-product to the card DOM */
  function applyProduct(card, prod, products) {
    if (!prod) return;

    // Image — handle both plain <img src> and lazyload <img data-src>
    var img = card.querySelector('[data-grid-image]');
    if (img && prod.image) {
      var isLazy = img.classList.contains('lazyload')
                || img.classList.contains('lazyloaded')
                || img.classList.contains('ls-is-cached')
                || img.hasAttribute('data-src');

      if (isLazy) {
        // Reset lazyload state so the library reprocesses this <img>
        img.classList.remove('lazyloaded', 'ls-is-cached', 'ls-inview', 'ls-loaded');
        img.setAttribute('data-src', prod.image);
        img.removeAttribute('srcset');
        img.removeAttribute('data-srcset');
        if (!img.classList.contains('lazyload')) img.classList.add('lazyload');
        // Drop any stale width-template src
        img.removeAttribute('src');
        if (window.lazySizes && typeof window.lazySizes.loader === 'object' && typeof window.lazySizes.loader.unveil === 'function') {
          window.lazySizes.loader.unveil(img);
        }
      } else {
        img.src = prod.image;
      }
      img.alt = prod.imageAlt;
    }

    // Links (image link + title link)
    var imgLink   = card.querySelector('[data-grid-image-link]');
    var titleLink = card.querySelector('[data-grid-title-link]');
    if (imgLink)   imgLink.href   = prod.url;
    if (titleLink) {
      titleLink.href = prod.url;
      if (prod.title) {
        titleLink.textContent = prod.title;
      }
    }

    // Price — innerHTML preserves the <span class="money"> tag that | money outputs,
    // so currency switchers can find and convert it
    var currEl = card.querySelector('[data-grid-price-current]');
    var compEl = card.querySelector('[data-grid-price-compare]');
    if (currEl) currEl.innerHTML = prod.priceFmt;
    if (compEl) {
      if (prod.comparePrice > 0 && prod.comparePriceFmt) {
        compEl.innerHTML = prod.comparePriceFmt;
        compEl.hidden = false;
      } else {
        compEl.hidden = true;
      }
    }

    // Cone count badge — cone count is a property of the size, so if the
    // matched product itself has no value, fall back to any product sharing
    // the same length that does (guards against the metafield only being
    // filled in on one of several same-size linked products).
    var coneBadge = card.querySelector('.cone-count-badge');
    if (coneBadge) {
      var conesCount = prod.conesCount;
      if (!conesCount && products) {
        var sameLengthMatch = products.find(function (p) {
          return p.length === prod.length && p.conesCount;
        });
        if (sameLengthMatch) conesCount = sameLengthMatch.conesCount;
      }
      if (conesCount) {
        coneBadge.textContent = conesCount + ' Units';
        coneBadge.hidden = false;
      } else {
        coneBadge.hidden = true;
      }
    }

    // ATC wrapper — update variant-id and reset qty UI
    var atcWrap = card.querySelector('.grid-atc');
    if (atcWrap) {
      var atcBtn    = atcWrap.querySelector('.grid-atc__btn');
      var qtyWrap   = atcWrap.querySelector('.grid-atc__qty');
      var soldoutBtn = atcWrap.querySelector('[data-soldout-btn]');

      if (prod.available) {
        atcWrap.dataset.variantId = prod.variantId;
        atcWrap.classList.remove('grid-atc--soldout');
        // Show ATC button, hide qty
        if (atcBtn) { atcBtn.style.display = ''; atcBtn.disabled = false; }
        if (qtyWrap) qtyWrap.hidden = true;
        if (soldoutBtn) soldoutBtn.hidden = true;
      } else {
        atcWrap.dataset.variantId = '';
        atcWrap.classList.add('grid-atc--soldout');
        if (atcBtn) atcBtn.style.display = 'none';
        if (qtyWrap) qtyWrap.hidden = true;
        if (soldoutBtn) { soldoutBtn.hidden = false; }
      }
    }
  }

  /** Boot the selector on a single card element */
  function initCard(card) {
    if (card._mxLinkedInit) return;
    card._mxLinkedInit = true;

    var products = parseLinkedData(card);
    if (!products.length) return;

    var activePaper  = '';
    var activeLength = '';

    // Seed from currently-active swatch / dropdown
    var activeSwatch = card.querySelector('.mx_grid_swatch_btn.is-active');
    var sizeSelect   = card.querySelector('.mx_grid_size_select');
    if (activeSwatch)  activePaper  = activeSwatch.dataset.value || '';
    if (sizeSelect)    activeLength = sizeSelect.value || '';

    // Fallback to first product
    if (!activePaper  && products[0]) activePaper  = products[0].paper;
    if (!activeLength && products[0]) activeLength = products[0].length;

    // ----- Swiper swatch carousel -----
    var swatchSlider = card.querySelector('.mx_grid_swatch_slider');
    if (swatchSlider && !swatchSlider.dataset.swiperInit && typeof Swiper !== 'undefined') {
      swatchSlider.dataset.swiperInit = '1';
      new Swiper(swatchSlider, {
        slidesPerView: 'auto',
        spaceBetween: 6,
        freeMode: true,
        watchOverflow: true,
        navigation: {
          nextEl: swatchSlider.querySelector('.mx_grid_swatch_nav--next'),
          prevEl: swatchSlider.querySelector('.mx_grid_swatch_nav--prev'),
          disabledClass: 'mx_grid_swatch_nav--disabled',
        },
      });
    }

    // ----- swatch click -----
    card.querySelectorAll('.mx_grid_swatch_btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (this.disabled || this.classList.contains('is-disabled')) return;
        var paper = this.dataset.value;
        activePaper = paper;

        // Toggle active class
        card.querySelectorAll('.mx_grid_swatch_btn').forEach(function (b) {
          var on = b.dataset.value === paper;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        // Find best product for new paper
        var prod = findProduct(products, paper, activeLength);
        if (prod) {
          activeLength = prod.length;
          // Sync dropdown
          if (sizeSelect && sizeSelect.value !== activeLength) {
            sizeSelect.value = activeLength;
          }
          applyProduct(card, prod, products);
        }
        updateAvailability(card, products, activePaper, activeLength);
      });
    });

    // ----- size dropdown change -----
    if (sizeSelect) {
      sizeSelect.addEventListener('change', function () {
        activeLength = this.value;
        var prod = findProduct(products, activePaper, activeLength);
        if (prod) {
          activePaper = prod.paper;
          card.querySelectorAll('.mx_grid_swatch_btn').forEach(function (btn) {
            var on = btn.dataset.value === activePaper;
            btn.classList.toggle('is-active', on);
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          applyProduct(card, prod, products);
        }
        updateAvailability(card, products, activePaper, activeLength);
      });
    }

    // Initial availability pass
    updateAvailability(card, products, activePaper, activeLength);
  }

  /** Init all linked-product cards currently in the DOM */
  function initAll() {
    document.querySelectorAll('.m-product-grid__item.has-linked-products').forEach(initCard);
  }

  // Run once on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Pick up cards added dynamically (infinite scroll / AJAX pagination)
  var _observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList.contains('has-linked-products')) {
          initCard(node);
        } else {
          node.querySelectorAll && node.querySelectorAll('.m-product-grid__item.has-linked-products').forEach(initCard);
        }
      });
    });
  });
  _observer.observe(document.body, { childList: true, subtree: true });
})();
